import React, { useCallback, useEffect } from 'react';
import { compose } from 'recompose';
import StpForm from './form/form.component';
import { hot } from 'react-hot-loader';
import { withStpForm } from './form.helper';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { withAxios } from 'op/components/auth/auth.helper';
import { useHistory } from 'react-router';
import { Button } from 'semantic-ui-react';

function FormContainer({
    locale,
    item,
    user,
    axios,
    saveForm,
    online,
    isEditing,
    stpForm,
    setStpForm,
    removeForm,
}) {
    const h = useHistory();

    const [report, setReport] = React.useState({
        signatures: {
            EmpSig: stpForm.data[0].STPMainSig ? `data:image/png;base64,${stpForm.data[0].STPMainSig}` : undefined,
        }
    });

    const invokeChange = useCallback((change) => setReport(update(report, change)), [report]);

    React.useEffect(() => {
        if (report.signatures.EmpSig)
            setStpForm((prev) => {
                const newStpForm = { ...prev };

                newStpForm.data.forEach((item) => {
                    item.STPMainSig = report.signatures.EmpSig.replace('data:image/png;base64,', '');
                });

                return newStpForm;
            });
    }, [report]);

    const onSubmit = async (values, formItemID) => {
        axios.post('/api/Stp/saveStpTestResult', values)
            .then(({ data }) => {
                removeForm(formItemID);
                h.push(`/stp/${item.item_ID}/tests`);
            });
    }

    const validateForm = async (values) => {
        try {
            const { data } = await axios.post('/api/Stp/validateStpTest', values);
            return data;
        } catch (error) {
            return false;
        }
    }

    useEffect(() => {
        saveForm(stpForm);
    }, [stpForm]);

    return (
        <div>
            <StpForm
                manufacturer={item.item_Name}
                model={item.item_Model}
                serialNumber={item.item_Serial}
                optimumPositionOfSTP={item.item_OptimumPosition}
                location={item.item_Location}
                user={user}
                itemId={item.item_ID}
                type={item.stpType}
                report={report}
                stpForm={stpForm}
                setStpForm={setStpForm}
                invokeChange={invokeChange}
                onSubmit={onSubmit}
                validateForm={validateForm}
            />
        </div>
    )
}

export default compose(
    hot(module),
    withStpForm,
    connect(
        ({ auth }) => ({
            user: auth.user,
        }),
    ),
    withAxios
)(FormContainer);
